// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.col{
  padding: 0px;
}

.card {
  min-height: 200px;
  background-color: #e5e5e5; /* Darker background color */
  border: 1px solid #ccc;
  border-radius: 50px;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-bottom: 20px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-weight: 500;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  word-wrap: break-word;
}

.card-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.card-text {
  word-wrap: break-word;
  overflow-wrap: break-word; 
  -ms-word-break: break-all; 
  word-break: break-word;
}

.card.selected {
  background-color: #009374;
  color: #fff;
}

button[type="submit"] {
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 10px 20px;
  background-color: #009374;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  z-index: 9999;
}

button[type="submit"]:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  button[type="submit"] {
    bottom: 25px;
    right: 20px;
    font-size: 1.2rem;
  }
}

.modal-content {
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  display: flex; /* Add display flex */
}



.modal-header {
  background-color: #f5f5f5;
  border-bottom: none;
}

.modal-title {
  font-size: 24px;
  font-weight: bold;
}

.modal-body {
  padding: 20px;
  font-size: 18px;
}

.card-info {
  margin-bottom: 10px;
  text-align: left;
}

.feedback {
  font-weight: bold;
}

.hint {
  font-style: italic;
}

.modal-footer {
  border-top: none;
  padding: 20px;
}

.close {
  color: #aaa;
  font-size: 28px;
  font-weight: bold;
  opacity: 0.8;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
  opacity: 1;
}

.card.non-clickable {
  background-color: gray;
  color: #fff;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Sub-Components/Card.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,yBAAyB,EAAE,4BAA4B;EACvD,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa,EAAE,qBAAqB;AACtC;;;;AAIA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB","sourcesContent":[".col{\n  padding: 0px;\n}\n\n.card {\n  min-height: 200px;\n  background-color: #e5e5e5; /* Darker background color */\n  border: 1px solid #ccc;\n  border-radius: 50px;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  margin-bottom: 20px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  font-weight: 500;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n  word-wrap: break-word;\n}\n\n.card-body {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.card-text {\n  word-wrap: break-word;\n  overflow-wrap: break-word; \n  -ms-word-break: break-all; \n  word-break: break-word;\n}\n\n.card.selected {\n  background-color: #009374;\n  color: #fff;\n}\n\nbutton[type=\"submit\"] {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  padding: 10px 20px;\n  background-color: #009374;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  z-index: 9999;\n}\n\nbutton[type=\"submit\"]:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n  button[type=\"submit\"] {\n    bottom: 25px;\n    right: 20px;\n    font-size: 1.2rem;\n  }\n}\n\n.modal-content {\n  border-radius: 10px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);\n  display: flex; /* Add display flex */\n}\n\n\n\n.modal-header {\n  background-color: #f5f5f5;\n  border-bottom: none;\n}\n\n.modal-title {\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.modal-body {\n  padding: 20px;\n  font-size: 18px;\n}\n\n.card-info {\n  margin-bottom: 10px;\n  text-align: left;\n}\n\n.feedback {\n  font-weight: bold;\n}\n\n.hint {\n  font-style: italic;\n}\n\n.modal-footer {\n  border-top: none;\n  padding: 20px;\n}\n\n.close {\n  color: #aaa;\n  font-size: 28px;\n  font-weight: bold;\n  opacity: 0.8;\n}\n\n.close:hover,\n.close:focus {\n  color: #000;\n  text-decoration: none;\n  cursor: pointer;\n  opacity: 1;\n}\n\n.card.non-clickable {\n  background-color: gray;\n  color: #fff;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
